// eslint-disable-next-line simple-import-sort/imports
import '@mantine/core/styles.css'
import '@mantine/notifications/styles.css'
import '@mantine/charts/styles.css'
import '@mantine/dates/styles.css'

import { MantineProvider } from '@mantine/core'
import { ModalsProvider } from '@mantine/modals'
import { Notifications } from '@mantine/notifications'
import { Router } from '@router/Router'
import { themeOverride, themeResolver } from '@theme/theme'

import { ReactQueryProvider } from '@/providers/ReactQuery'

function App() {
  return (
    <ReactQueryProvider>
      <MantineProvider
        cssVariablesResolver={themeResolver}
        theme={themeOverride}
      >
        <Notifications position="top-right" />

        <ModalsProvider>
          <Router />
        </ModalsProvider>
      </MantineProvider>
    </ReactQueryProvider>
  )
}

export default App
